module.exports = __webpack_public_path__ + "static/media/ps.1cde6f32.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ps.svg
// module id = 2192
// module chunks = 0